export const exteriorView04ImageOptions = {
  angle: 'ExteriorView04',
  staticOptions: {
    HullColorways: 1,
    Bowsprit: 1,
    HullTreatment: 1,
    BathingLadder: 1,
    CockpitLockers: 1,
    RemovableFootChocks: 1,
    RemovableCockpitTable: 1,
    Sprayhood: 1,
    BoomCover: 1,
    Mainsail: 1,
    Flag: 1
  },
  mattes: [
    {
      option: 'HullColorways',
      dependency: null
    },
    {
      option: 'BathingLadder',
      dependency: null
    },
    {
      option: 'CockpitLockers',
      dependency: null
    },
    {
      option: 'RemovableFootChocks',
      dependency: null
    },
    {
      option: 'RemovableCockpitTable',
      dependency: null
    },
    {
      option: 'Sprayhood',
      dependency: null
    },
    {
      option: 'BoomCover',
      dependency: null
    },
    {
      option: 'Mainsail',
      dependency: null
    }
  ],
  overlays: [
    {
      option: 'BathingLadder',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xr41/views/ExteriorView04.js